import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { PropsWithChildren, useContext } from "react";
import { useNavigate } from "react-router-dom";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { ContextDamageForm } from "./DamageFormContext";

const SectionCardHeader = (props: PropsWithChildren) => {
  const { generalInfo } = useContext(ContextDamageForm);
  const navigate = useNavigate();

  const t = useOperationTranslation();
  
  return (
    <Mui.CardHeader
      title={
          <Mui.Typography variant="h5">
              {`${t("damageForm.details.common.cardHeaderSection.lblFormCode")} ${generalInfo?.progressive}`}
          </Mui.Typography>
      }
      avatar={
          <Mui.IconButton onClick={() => navigate("/operation/damages/forms")}>
              <MuiIcons.ArrowBack />
          </Mui.IconButton>
      }
      action={props.children}
    />
  )
}

export default SectionCardHeader;